/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as TeamDefs from '../team/defs.defs.js'
import * as ModerationDefs from '../moderation/defs.defs.js'
import * as ModerationDefs$$0 from '../../../com/atproto/moderation/defs.defs.js'
import * as QueueDefs from '../queue/defs.defs.js'

const $nsid = 'tools.ozone.report.defs'

export { $nsid }

type ReasonType =
  | 'tools.ozone.report.defs#reasonAppeal'
  | 'tools.ozone.report.defs#reasonOther'
  | 'tools.ozone.report.defs#reasonViolenceAnimal'
  | 'tools.ozone.report.defs#reasonViolenceThreats'
  | 'tools.ozone.report.defs#reasonViolenceGraphicContent'
  | 'tools.ozone.report.defs#reasonViolenceGlorification'
  | 'tools.ozone.report.defs#reasonViolenceExtremistContent'
  | 'tools.ozone.report.defs#reasonViolenceTrafficking'
  | 'tools.ozone.report.defs#reasonViolenceOther'
  | 'tools.ozone.report.defs#reasonSexualAbuseContent'
  | 'tools.ozone.report.defs#reasonSexualNCII'
  | 'tools.ozone.report.defs#reasonSexualDeepfake'
  | 'tools.ozone.report.defs#reasonSexualAnimal'
  | 'tools.ozone.report.defs#reasonSexualUnlabeled'
  | 'tools.ozone.report.defs#reasonSexualOther'
  | 'tools.ozone.report.defs#reasonChildSafetyCSAM'
  | 'tools.ozone.report.defs#reasonChildSafetyGroom'
  | 'tools.ozone.report.defs#reasonChildSafetyPrivacy'
  | 'tools.ozone.report.defs#reasonChildSafetyHarassment'
  | 'tools.ozone.report.defs#reasonChildSafetyOther'
  | 'tools.ozone.report.defs#reasonHarassmentTroll'
  | 'tools.ozone.report.defs#reasonHarassmentTargeted'
  | 'tools.ozone.report.defs#reasonHarassmentHateSpeech'
  | 'tools.ozone.report.defs#reasonHarassmentDoxxing'
  | 'tools.ozone.report.defs#reasonHarassmentOther'
  | 'tools.ozone.report.defs#reasonMisleadingBot'
  | 'tools.ozone.report.defs#reasonMisleadingImpersonation'
  | 'tools.ozone.report.defs#reasonMisleadingSpam'
  | 'tools.ozone.report.defs#reasonMisleadingScam'
  | 'tools.ozone.report.defs#reasonMisleadingElections'
  | 'tools.ozone.report.defs#reasonMisleadingOther'
  | 'tools.ozone.report.defs#reasonRuleSiteSecurity'
  | 'tools.ozone.report.defs#reasonRuleProhibitedSales'
  | 'tools.ozone.report.defs#reasonRuleBanEvasion'
  | 'tools.ozone.report.defs#reasonRuleOther'
  | 'tools.ozone.report.defs#reasonSelfHarmContent'
  | 'tools.ozone.report.defs#reasonSelfHarmED'
  | 'tools.ozone.report.defs#reasonSelfHarmStunts'
  | 'tools.ozone.report.defs#reasonSelfHarmSubstances'
  | 'tools.ozone.report.defs#reasonSelfHarmOther'
  | l.UnknownString

export type { ReasonType }

const reasonType = /*#__PURE__*/ l.string<{
  knownValues: [
    'tools.ozone.report.defs#reasonAppeal',
    'tools.ozone.report.defs#reasonOther',
    'tools.ozone.report.defs#reasonViolenceAnimal',
    'tools.ozone.report.defs#reasonViolenceThreats',
    'tools.ozone.report.defs#reasonViolenceGraphicContent',
    'tools.ozone.report.defs#reasonViolenceGlorification',
    'tools.ozone.report.defs#reasonViolenceExtremistContent',
    'tools.ozone.report.defs#reasonViolenceTrafficking',
    'tools.ozone.report.defs#reasonViolenceOther',
    'tools.ozone.report.defs#reasonSexualAbuseContent',
    'tools.ozone.report.defs#reasonSexualNCII',
    'tools.ozone.report.defs#reasonSexualDeepfake',
    'tools.ozone.report.defs#reasonSexualAnimal',
    'tools.ozone.report.defs#reasonSexualUnlabeled',
    'tools.ozone.report.defs#reasonSexualOther',
    'tools.ozone.report.defs#reasonChildSafetyCSAM',
    'tools.ozone.report.defs#reasonChildSafetyGroom',
    'tools.ozone.report.defs#reasonChildSafetyPrivacy',
    'tools.ozone.report.defs#reasonChildSafetyHarassment',
    'tools.ozone.report.defs#reasonChildSafetyOther',
    'tools.ozone.report.defs#reasonHarassmentTroll',
    'tools.ozone.report.defs#reasonHarassmentTargeted',
    'tools.ozone.report.defs#reasonHarassmentHateSpeech',
    'tools.ozone.report.defs#reasonHarassmentDoxxing',
    'tools.ozone.report.defs#reasonHarassmentOther',
    'tools.ozone.report.defs#reasonMisleadingBot',
    'tools.ozone.report.defs#reasonMisleadingImpersonation',
    'tools.ozone.report.defs#reasonMisleadingSpam',
    'tools.ozone.report.defs#reasonMisleadingScam',
    'tools.ozone.report.defs#reasonMisleadingElections',
    'tools.ozone.report.defs#reasonMisleadingOther',
    'tools.ozone.report.defs#reasonRuleSiteSecurity',
    'tools.ozone.report.defs#reasonRuleProhibitedSales',
    'tools.ozone.report.defs#reasonRuleBanEvasion',
    'tools.ozone.report.defs#reasonRuleOther',
    'tools.ozone.report.defs#reasonSelfHarmContent',
    'tools.ozone.report.defs#reasonSelfHarmED',
    'tools.ozone.report.defs#reasonSelfHarmStunts',
    'tools.ozone.report.defs#reasonSelfHarmSubstances',
    'tools.ozone.report.defs#reasonSelfHarmOther',
  ]
}>()

export { reasonType }

/** Appeal a previously taken moderation action */
type ReasonAppeal = 'tools.ozone.report.defs#reasonAppeal'

export type { ReasonAppeal }

/** Appeal a previously taken moderation action */
const reasonAppeal = /*#__PURE__*/ l.token($nsid, 'reasonAppeal')

export { reasonAppeal }

/** An issue not included in these options */
type ReasonOther = 'tools.ozone.report.defs#reasonOther'

export type { ReasonOther }

/** An issue not included in these options */
const reasonOther = /*#__PURE__*/ l.token($nsid, 'reasonOther')

export { reasonOther }

/** Animal welfare violations */
type ReasonViolenceAnimal = 'tools.ozone.report.defs#reasonViolenceAnimal'

export type { ReasonViolenceAnimal }

/** Animal welfare violations */
const reasonViolenceAnimal = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceAnimal',
)

export { reasonViolenceAnimal }

/** Threats or incitement */
type ReasonViolenceThreats = 'tools.ozone.report.defs#reasonViolenceThreats'

export type { ReasonViolenceThreats }

/** Threats or incitement */
const reasonViolenceThreats = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceThreats',
)

export { reasonViolenceThreats }

/** Graphic violent content */
type ReasonViolenceGraphicContent =
  'tools.ozone.report.defs#reasonViolenceGraphicContent'

export type { ReasonViolenceGraphicContent }

/** Graphic violent content */
const reasonViolenceGraphicContent = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceGraphicContent',
)

export { reasonViolenceGraphicContent }

/** Glorification of violence */
type ReasonViolenceGlorification =
  'tools.ozone.report.defs#reasonViolenceGlorification'

export type { ReasonViolenceGlorification }

/** Glorification of violence */
const reasonViolenceGlorification = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceGlorification',
)

export { reasonViolenceGlorification }

/** Extremist content. These reports will be sent only be sent to the application's Moderation Authority. */
type ReasonViolenceExtremistContent =
  'tools.ozone.report.defs#reasonViolenceExtremistContent'

export type { ReasonViolenceExtremistContent }

/** Extremist content. These reports will be sent only be sent to the application's Moderation Authority. */
const reasonViolenceExtremistContent = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceExtremistContent',
)

export { reasonViolenceExtremistContent }

/** Human trafficking */
type ReasonViolenceTrafficking =
  'tools.ozone.report.defs#reasonViolenceTrafficking'

export type { ReasonViolenceTrafficking }

/** Human trafficking */
const reasonViolenceTrafficking = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceTrafficking',
)

export { reasonViolenceTrafficking }

/** Other violent content */
type ReasonViolenceOther = 'tools.ozone.report.defs#reasonViolenceOther'

export type { ReasonViolenceOther }

/** Other violent content */
const reasonViolenceOther = /*#__PURE__*/ l.token($nsid, 'reasonViolenceOther')

export { reasonViolenceOther }

/** Adult sexual abuse content */
type ReasonSexualAbuseContent =
  'tools.ozone.report.defs#reasonSexualAbuseContent'

export type { ReasonSexualAbuseContent }

/** Adult sexual abuse content */
const reasonSexualAbuseContent = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSexualAbuseContent',
)

export { reasonSexualAbuseContent }

/** Non-consensual intimate imagery */
type ReasonSexualNCII = 'tools.ozone.report.defs#reasonSexualNCII'

export type { ReasonSexualNCII as ReasonSexualNcii }

/** Non-consensual intimate imagery */
const reasonSexualNCII = /*#__PURE__*/ l.token($nsid, 'reasonSexualNCII')

export { reasonSexualNCII }

/** Deepfake adult content */
type ReasonSexualDeepfake = 'tools.ozone.report.defs#reasonSexualDeepfake'

export type { ReasonSexualDeepfake }

/** Deepfake adult content */
const reasonSexualDeepfake = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSexualDeepfake',
)

export { reasonSexualDeepfake }

/** Animal sexual abuse */
type ReasonSexualAnimal = 'tools.ozone.report.defs#reasonSexualAnimal'

export type { ReasonSexualAnimal }

/** Animal sexual abuse */
const reasonSexualAnimal = /*#__PURE__*/ l.token($nsid, 'reasonSexualAnimal')

export { reasonSexualAnimal }

/** Unlabelled adult content */
type ReasonSexualUnlabeled = 'tools.ozone.report.defs#reasonSexualUnlabeled'

export type { ReasonSexualUnlabeled }

/** Unlabelled adult content */
const reasonSexualUnlabeled = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSexualUnlabeled',
)

export { reasonSexualUnlabeled }

/** Other sexual violence content */
type ReasonSexualOther = 'tools.ozone.report.defs#reasonSexualOther'

export type { ReasonSexualOther }

/** Other sexual violence content */
const reasonSexualOther = /*#__PURE__*/ l.token($nsid, 'reasonSexualOther')

export { reasonSexualOther }

/** Child sexual abuse material (CSAM). These reports will be sent only be sent to the application's Moderation Authority. */
type ReasonChildSafetyCSAM = 'tools.ozone.report.defs#reasonChildSafetyCSAM'

export type { ReasonChildSafetyCSAM as ReasonChildSafetyCsam }

/** Child sexual abuse material (CSAM). These reports will be sent only be sent to the application's Moderation Authority. */
const reasonChildSafetyCSAM = /*#__PURE__*/ l.token(
  $nsid,
  'reasonChildSafetyCSAM',
)

export { reasonChildSafetyCSAM }

/** Grooming or predatory behavior. These reports will be sent only be sent to the application's Moderation Authority. */
type ReasonChildSafetyGroom = 'tools.ozone.report.defs#reasonChildSafetyGroom'

export type { ReasonChildSafetyGroom }

/** Grooming or predatory behavior. These reports will be sent only be sent to the application's Moderation Authority. */
const reasonChildSafetyGroom = /*#__PURE__*/ l.token(
  $nsid,
  'reasonChildSafetyGroom',
)

export { reasonChildSafetyGroom }

/** Privacy violation involving a minor */
type ReasonChildSafetyPrivacy =
  'tools.ozone.report.defs#reasonChildSafetyPrivacy'

export type { ReasonChildSafetyPrivacy }

/** Privacy violation involving a minor */
const reasonChildSafetyPrivacy = /*#__PURE__*/ l.token(
  $nsid,
  'reasonChildSafetyPrivacy',
)

export { reasonChildSafetyPrivacy }

/** Harassment or bullying of minors */
type ReasonChildSafetyHarassment =
  'tools.ozone.report.defs#reasonChildSafetyHarassment'

export type { ReasonChildSafetyHarassment }

/** Harassment or bullying of minors */
const reasonChildSafetyHarassment = /*#__PURE__*/ l.token(
  $nsid,
  'reasonChildSafetyHarassment',
)

export { reasonChildSafetyHarassment }

/** Other child safety. These reports will be sent only be sent to the application's Moderation Authority. */
type ReasonChildSafetyOther = 'tools.ozone.report.defs#reasonChildSafetyOther'

export type { ReasonChildSafetyOther }

/** Other child safety. These reports will be sent only be sent to the application's Moderation Authority. */
const reasonChildSafetyOther = /*#__PURE__*/ l.token(
  $nsid,
  'reasonChildSafetyOther',
)

export { reasonChildSafetyOther }

/** Trolling */
type ReasonHarassmentTroll = 'tools.ozone.report.defs#reasonHarassmentTroll'

export type { ReasonHarassmentTroll }

/** Trolling */
const reasonHarassmentTroll = /*#__PURE__*/ l.token(
  $nsid,
  'reasonHarassmentTroll',
)

export { reasonHarassmentTroll }

/** Targeted harassment */
type ReasonHarassmentTargeted =
  'tools.ozone.report.defs#reasonHarassmentTargeted'

export type { ReasonHarassmentTargeted }

/** Targeted harassment */
const reasonHarassmentTargeted = /*#__PURE__*/ l.token(
  $nsid,
  'reasonHarassmentTargeted',
)

export { reasonHarassmentTargeted }

/** Hate speech */
type ReasonHarassmentHateSpeech =
  'tools.ozone.report.defs#reasonHarassmentHateSpeech'

export type { ReasonHarassmentHateSpeech }

/** Hate speech */
const reasonHarassmentHateSpeech = /*#__PURE__*/ l.token(
  $nsid,
  'reasonHarassmentHateSpeech',
)

export { reasonHarassmentHateSpeech }

/** Doxxing */
type ReasonHarassmentDoxxing = 'tools.ozone.report.defs#reasonHarassmentDoxxing'

export type { ReasonHarassmentDoxxing }

/** Doxxing */
const reasonHarassmentDoxxing = /*#__PURE__*/ l.token(
  $nsid,
  'reasonHarassmentDoxxing',
)

export { reasonHarassmentDoxxing }

/** Other harassing or hateful content */
type ReasonHarassmentOther = 'tools.ozone.report.defs#reasonHarassmentOther'

export type { ReasonHarassmentOther }

/** Other harassing or hateful content */
const reasonHarassmentOther = /*#__PURE__*/ l.token(
  $nsid,
  'reasonHarassmentOther',
)

export { reasonHarassmentOther }

/** Fake account or bot */
type ReasonMisleadingBot = 'tools.ozone.report.defs#reasonMisleadingBot'

export type { ReasonMisleadingBot }

/** Fake account or bot */
const reasonMisleadingBot = /*#__PURE__*/ l.token($nsid, 'reasonMisleadingBot')

export { reasonMisleadingBot }

/** Impersonation */
type ReasonMisleadingImpersonation =
  'tools.ozone.report.defs#reasonMisleadingImpersonation'

export type { ReasonMisleadingImpersonation }

/** Impersonation */
const reasonMisleadingImpersonation = /*#__PURE__*/ l.token(
  $nsid,
  'reasonMisleadingImpersonation',
)

export { reasonMisleadingImpersonation }

/** Spam */
type ReasonMisleadingSpam = 'tools.ozone.report.defs#reasonMisleadingSpam'

export type { ReasonMisleadingSpam }

/** Spam */
const reasonMisleadingSpam = /*#__PURE__*/ l.token(
  $nsid,
  'reasonMisleadingSpam',
)

export { reasonMisleadingSpam }

/** Scam */
type ReasonMisleadingScam = 'tools.ozone.report.defs#reasonMisleadingScam'

export type { ReasonMisleadingScam }

/** Scam */
const reasonMisleadingScam = /*#__PURE__*/ l.token(
  $nsid,
  'reasonMisleadingScam',
)

export { reasonMisleadingScam }

/** False information about elections */
type ReasonMisleadingElections =
  'tools.ozone.report.defs#reasonMisleadingElections'

export type { ReasonMisleadingElections }

/** False information about elections */
const reasonMisleadingElections = /*#__PURE__*/ l.token(
  $nsid,
  'reasonMisleadingElections',
)

export { reasonMisleadingElections }

/** Other misleading content */
type ReasonMisleadingOther = 'tools.ozone.report.defs#reasonMisleadingOther'

export type { ReasonMisleadingOther }

/** Other misleading content */
const reasonMisleadingOther = /*#__PURE__*/ l.token(
  $nsid,
  'reasonMisleadingOther',
)

export { reasonMisleadingOther }

/** Hacking or system attacks */
type ReasonRuleSiteSecurity = 'tools.ozone.report.defs#reasonRuleSiteSecurity'

export type { ReasonRuleSiteSecurity }

/** Hacking or system attacks */
const reasonRuleSiteSecurity = /*#__PURE__*/ l.token(
  $nsid,
  'reasonRuleSiteSecurity',
)

export { reasonRuleSiteSecurity }

/** Promoting or selling prohibited items or services */
type ReasonRuleProhibitedSales =
  'tools.ozone.report.defs#reasonRuleProhibitedSales'

export type { ReasonRuleProhibitedSales }

/** Promoting or selling prohibited items or services */
const reasonRuleProhibitedSales = /*#__PURE__*/ l.token(
  $nsid,
  'reasonRuleProhibitedSales',
)

export { reasonRuleProhibitedSales }

/** Banned user returning */
type ReasonRuleBanEvasion = 'tools.ozone.report.defs#reasonRuleBanEvasion'

export type { ReasonRuleBanEvasion }

/** Banned user returning */
const reasonRuleBanEvasion = /*#__PURE__*/ l.token(
  $nsid,
  'reasonRuleBanEvasion',
)

export { reasonRuleBanEvasion }

/** Other */
type ReasonRuleOther = 'tools.ozone.report.defs#reasonRuleOther'

export type { ReasonRuleOther }

/** Other */
const reasonRuleOther = /*#__PURE__*/ l.token($nsid, 'reasonRuleOther')

export { reasonRuleOther }

/** Content promoting or depicting self-harm */
type ReasonSelfHarmContent = 'tools.ozone.report.defs#reasonSelfHarmContent'

export type { ReasonSelfHarmContent }

/** Content promoting or depicting self-harm */
const reasonSelfHarmContent = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSelfHarmContent',
)

export { reasonSelfHarmContent }

/** Eating disorders */
type ReasonSelfHarmED = 'tools.ozone.report.defs#reasonSelfHarmED'

export type { ReasonSelfHarmED as ReasonSelfHarmEd }

/** Eating disorders */
const reasonSelfHarmED = /*#__PURE__*/ l.token($nsid, 'reasonSelfHarmED')

export { reasonSelfHarmED }

/** Dangerous challenges or activities */
type ReasonSelfHarmStunts = 'tools.ozone.report.defs#reasonSelfHarmStunts'

export type { ReasonSelfHarmStunts }

/** Dangerous challenges or activities */
const reasonSelfHarmStunts = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSelfHarmStunts',
)

export { reasonSelfHarmStunts }

/** Dangerous substances or drug abuse */
type ReasonSelfHarmSubstances =
  'tools.ozone.report.defs#reasonSelfHarmSubstances'

export type { ReasonSelfHarmSubstances }

/** Dangerous substances or drug abuse */
const reasonSelfHarmSubstances = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSelfHarmSubstances',
)

export { reasonSelfHarmSubstances }

/** Other dangerous content */
type ReasonSelfHarmOther = 'tools.ozone.report.defs#reasonSelfHarmOther'

export type { ReasonSelfHarmOther }

/** Other dangerous content */
const reasonSelfHarmOther = /*#__PURE__*/ l.token($nsid, 'reasonSelfHarmOther')

export { reasonSelfHarmOther }

/** Information about the moderator currently assigned to a report. */
type ReportAssignment = {
  $type?: 'tools.ozone.report.defs#reportAssignment'

  /**
   * DID of the assigned moderator
   */
  did: l.DidString

  /**
   * Full member record of the assigned moderator
   */
  moderator?: TeamDefs.Member

  /**
   * When the report was assigned
   */
  assignedAt: l.DatetimeString
}

export type { ReportAssignment }

/** Information about the moderator currently assigned to a report. */
const reportAssignment = /*#__PURE__*/ l.typedObject<ReportAssignment>(
  $nsid,
  'reportAssignment',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    moderator: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<TeamDefs.Member>((() => TeamDefs.member) as any),
    ),
    assignedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { reportAssignment }

type ReportView = {
  $type?: 'tools.ozone.report.defs#reportView'

  /**
   * Report ID
   */
  id: number

  /**
   * ID of the moderation event that created this report
   */
  eventId: number

  /**
   * Current status of the report
   */
  status:
    | 'open'
    | 'closed'
    | 'escalated'
    | 'queued'
    | 'assigned'
    | l.UnknownString

  /**
   * The subject that was reported with full details
   */
  subject: ModerationDefs.SubjectView

  /**
   * Type of report
   */
  reportType: ModerationDefs$$0.ReasonType

  /**
   * DID of the user who made the report
   */
  reportedBy: l.DidString

  /**
   * Full subject view of the reporter account
   */
  reporter: ModerationDefs.SubjectView

  /**
   * Comment provided by the reporter
   */
  comment?: string

  /**
   * When the report was created
   */
  createdAt: l.DatetimeString

  /**
   * When the report was last updated
   */
  updatedAt?: l.DatetimeString

  /**
   * When the report was assigned to its current queue
   */
  queuedAt?: l.DatetimeString

  /**
   * Array of moderation event IDs representing actions taken on this report (sorted DESC, most recent first)
   */
  actionEventIds?: number[]

  /**
   * Optional: expanded action events
   */
  actions?: ModerationDefs.ModEventView[]

  /**
   * Note sent to reporter when report was actioned
   */
  actionNote?: string

  /**
   * Current status of the reported subject
   */
  subjectStatus?: ModerationDefs.SubjectStatusView

  /**
   * Number of other pending reports on the same subject
   */
  relatedReportCount?: number

  /**
   * Information about moderator currently assigned to this report (if any)
   */
  assignment?: ReportAssignment

  /**
   * The queue this report is assigned to (if any)
   */
  queue?: QueueDefs.QueueView

  /**
   * Whether this report is muted. A report is muted if the reporter was muted or the subject was muted at the time the report was created.
   */
  isMuted?: boolean

  /**
   * Whether this report was emitted by automated tooling.
   */
  isAutomated?: boolean
}

export type { ReportView }

const reportView = /*#__PURE__*/ l.typedObject<ReportView>(
  $nsid,
  'reportView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    eventId: /*#__PURE__*/ l.integer(),
    status: /*#__PURE__*/ l.string<{
      knownValues: ['open', 'closed', 'escalated', 'queued', 'assigned']
    }>(),
    subject: /*#__PURE__*/ l.ref<ModerationDefs.SubjectView>(
      (() => ModerationDefs.subjectView) as any,
    ),
    reportType: /*#__PURE__*/ l.ref<ModerationDefs$$0.ReasonType>(
      (() => ModerationDefs$$0.reasonType) as any,
    ),
    reportedBy: /*#__PURE__*/ l.string({ format: 'did' }),
    reporter: /*#__PURE__*/ l.ref<ModerationDefs.SubjectView>(
      (() => ModerationDefs.subjectView) as any,
    ),
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    updatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    queuedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    actionEventIds: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.integer()),
    ),
    actions: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<ModerationDefs.ModEventView>(
          (() => ModerationDefs.modEventView) as any,
        ),
      ),
    ),
    actionNote: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    subjectStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ModerationDefs.SubjectStatusView>(
        (() => ModerationDefs.subjectStatusView) as any,
      ),
    ),
    relatedReportCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    assignment: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ReportAssignment>((() => reportAssignment) as any),
    ),
    queue: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<QueueDefs.QueueView>(
        (() => QueueDefs.queueView) as any,
      ),
    ),
    isMuted: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    isAutomated: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.boolean(), false),
    ),
  }),
)

export { reportView }

/** Activity recording a report being routed to a queue. */
type QueueActivity = {
  $type?: 'tools.ozone.report.defs#queueActivity'

  /**
   * The report's status before this activity. Populated automatically from the report row; not required in input.
   */
  previousStatus?:
    | 'open'
    | 'closed'
    | 'escalated'
    | 'queued'
    | 'assigned'
    | l.UnknownString
}

export type { QueueActivity }

/** Activity recording a report being routed to a queue. */
const queueActivity = /*#__PURE__*/ l.typedObject<QueueActivity>(
  $nsid,
  'queueActivity',
  /*#__PURE__*/ l.object({
    previousStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: ['open', 'closed', 'escalated', 'queued', 'assigned']
      }>(),
    ),
  }),
)

export { queueActivity }

/** Activity recording a moderator being assigned to a report. */
type AssignmentActivity = {
  $type?: 'tools.ozone.report.defs#assignmentActivity'

  /**
   * The report's status before this activity. Populated automatically from the report row; not required in input.
   */
  previousStatus?:
    | 'open'
    | 'closed'
    | 'escalated'
    | 'queued'
    | 'assigned'
    | l.UnknownString
}

export type { AssignmentActivity }

/** Activity recording a moderator being assigned to a report. */
const assignmentActivity = /*#__PURE__*/ l.typedObject<AssignmentActivity>(
  $nsid,
  'assignmentActivity',
  /*#__PURE__*/ l.object({
    previousStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: ['open', 'closed', 'escalated', 'queued', 'assigned']
      }>(),
    ),
  }),
)

export { assignmentActivity }

/** Activity recording a report being escalated. */
type EscalationActivity = {
  $type?: 'tools.ozone.report.defs#escalationActivity'

  /**
   * The report's status before this activity. Populated automatically from the report row; not required in input.
   */
  previousStatus?:
    | 'open'
    | 'closed'
    | 'escalated'
    | 'queued'
    | 'assigned'
    | l.UnknownString
}

export type { EscalationActivity }

/** Activity recording a report being escalated. */
const escalationActivity = /*#__PURE__*/ l.typedObject<EscalationActivity>(
  $nsid,
  'escalationActivity',
  /*#__PURE__*/ l.object({
    previousStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: ['open', 'closed', 'escalated', 'queued', 'assigned']
      }>(),
    ),
  }),
)

export { escalationActivity }

/** Activity recording a report being closed. */
type CloseActivity = {
  $type?: 'tools.ozone.report.defs#closeActivity'

  /**
   * The report's status before this activity. Populated automatically from the report row; not required in input.
   */
  previousStatus?:
    | 'open'
    | 'closed'
    | 'escalated'
    | 'queued'
    | 'assigned'
    | l.UnknownString
}

export type { CloseActivity }

/** Activity recording a report being closed. */
const closeActivity = /*#__PURE__*/ l.typedObject<CloseActivity>(
  $nsid,
  'closeActivity',
  /*#__PURE__*/ l.object({
    previousStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: ['open', 'closed', 'escalated', 'queued', 'assigned']
      }>(),
    ),
  }),
)

export { closeActivity }

/** Activity recording a closed report being reopened. Only valid when the report is in 'closed' status. */
type ReopenActivity = {
  $type?: 'tools.ozone.report.defs#reopenActivity'

  /**
   * The report's status before this activity. Populated automatically from the report row; not required in input.
   */
  previousStatus?:
    | 'open'
    | 'closed'
    | 'escalated'
    | 'queued'
    | 'assigned'
    | l.UnknownString
}

export type { ReopenActivity }

/** Activity recording a closed report being reopened. Only valid when the report is in 'closed' status. */
const reopenActivity = /*#__PURE__*/ l.typedObject<ReopenActivity>(
  $nsid,
  'reopenActivity',
  /*#__PURE__*/ l.object({
    previousStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: ['open', 'closed', 'escalated', 'queued', 'assigned']
      }>(),
    ),
  }),
)

export { reopenActivity }

/** Activity recording a note on a report. Use internalNote for moderator-only notes or publicNote for reporter-visible notes (or both). */
type NoteActivity = { $type?: 'tools.ozone.report.defs#noteActivity' }

export type { NoteActivity }

/** Activity recording a note on a report. Use internalNote for moderator-only notes or publicNote for reporter-visible notes (or both). */
const noteActivity = /*#__PURE__*/ l.typedObject<NoteActivity>(
  $nsid,
  'noteActivity',
  /*#__PURE__*/ l.object({}),
)

export { noteActivity }

/** A single activity entry on a report. */
type ReportActivityView = {
  $type?: 'tools.ozone.report.defs#reportActivityView'

  /**
   * Activity ID
   */
  id: number

  /**
   * ID of the report this activity belongs to
   */
  reportId: number

  /**
   * The typed activity object describing what occurred.
   */
  activity:
    | l.$Typed<QueueActivity>
    | l.$Typed<AssignmentActivity>
    | l.$Typed<EscalationActivity>
    | l.$Typed<CloseActivity>
    | l.$Typed<ReopenActivity>
    | l.$Typed<NoteActivity>
    | l.Unknown$TypedObject

  /**
   * Optional moderator-only note. Not visible to reporters.
   */
  internalNote?: string

  /**
   * Optional public note, potentially visible to the reporter.
   */
  publicNote?: string

  /**
   * Extensible JSON payload for loose activity-specific metadata (e.g. assignmentId).
   */
  meta?: l.LexMap

  /**
   * True if this activity was created by an automated process (e.g. queue router) rather than a direct human action.
   */
  isAutomated: boolean

  /**
   * DID of the actor who created this activity, or the service DID for automated activities.
   */
  createdBy: l.DidString

  /**
   * Full member record of the moderator who created this activity
   */
  moderator?: TeamDefs.Member

  /**
   * Full view of the report this activity belongs to.
   */
  report?: ReportView

  /**
   * When this activity was created
   */
  createdAt: l.DatetimeString
}

export type { ReportActivityView }

/** A single activity entry on a report. */
const reportActivityView = /*#__PURE__*/ l.typedObject<ReportActivityView>(
  $nsid,
  'reportActivityView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    reportId: /*#__PURE__*/ l.integer(),
    activity: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<QueueActivity>((() => queueActivity) as any),
        /*#__PURE__*/ l.typedRef<AssignmentActivity>(
          (() => assignmentActivity) as any,
        ),
        /*#__PURE__*/ l.typedRef<EscalationActivity>(
          (() => escalationActivity) as any,
        ),
        /*#__PURE__*/ l.typedRef<CloseActivity>((() => closeActivity) as any),
        /*#__PURE__*/ l.typedRef<ReopenActivity>((() => reopenActivity) as any),
        /*#__PURE__*/ l.typedRef<NoteActivity>((() => noteActivity) as any),
      ],
      false,
    ),
    internalNote: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    publicNote: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    meta: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap()),
    isAutomated: /*#__PURE__*/ l.boolean(),
    createdBy: /*#__PURE__*/ l.string({ format: 'did' }),
    moderator: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<TeamDefs.Member>((() => TeamDefs.member) as any),
    ),
    report: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ReportView>((() => reportView) as any),
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { reportActivityView }

/** Live statistics for reports for the current calendar day, filterable by queue, moderator, or report type. */
type LiveStats = {
  $type?: 'tools.ozone.report.defs#liveStats'

  /**
   * Number of reports currently not closed.
   */
  pendingCount?: number

  /**
   * Number of reports closed today.
   */
  actionedCount?: number

  /**
   * Number of reports escalated today.
   */
  escalatedCount?: number

  /**
   * Reports received today.
   */
  inboundCount?: number

  /**
   * Percentage of reports actioned (actionedCount / inboundCount * 100), rounded to nearest integer.
   */
  actionRate?: number

  /**
   * Average time in seconds from report creation (or moderator assignment) to close.
   */
  avgHandlingTimeSec?: number

  /**
   * When these statistics were last computed.
   */
  lastUpdated?: l.DatetimeString
}

export type { LiveStats }

/** Live statistics for reports for the current calendar day, filterable by queue, moderator, or report type. */
const liveStats = /*#__PURE__*/ l.typedObject<LiveStats>(
  $nsid,
  'liveStats',
  /*#__PURE__*/ l.object({
    pendingCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    actionedCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    escalatedCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    inboundCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    actionRate: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    avgHandlingTimeSec: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    lastUpdated: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { liveStats }

/** A single daily snapshot of report statistics for a calendar date. */
type HistoricalStats = {
  $type?: 'tools.ozone.report.defs#historicalStats'

  /**
   * The calendar date this snapshot covers (YYYY-MM-DD).
   */
  date: string

  /**
   * When this snapshot was last computed.
   */
  computedAt?: l.DatetimeString

  /**
   * Number of reports not closed at time of computation.
   */
  pendingCount?: number

  /**
   * Number of reports closed during this day.
   */
  actionedCount?: number

  /**
   * Number of reports escalated during this day.
   */
  escalatedCount?: number

  /**
   * Reports received during this day.
   */
  inboundCount?: number

  /**
   * Percentage of reports actioned (actionedCount / inboundCount * 100), rounded to nearest integer.
   */
  actionRate?: number

  /**
   * Average time in seconds from report creation (or moderator assignment) to close.
   */
  avgHandlingTimeSec?: number
}

export type { HistoricalStats }

/** A single daily snapshot of report statistics for a calendar date. */
const historicalStats = /*#__PURE__*/ l.typedObject<HistoricalStats>(
  $nsid,
  'historicalStats',
  /*#__PURE__*/ l.object({
    date: /*#__PURE__*/ l.string(),
    computedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    pendingCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    actionedCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    escalatedCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    inboundCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    actionRate: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    avgHandlingTimeSec: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  }),
)

export { historicalStats }

type AssignmentView = {
  $type?: 'tools.ozone.report.defs#assignmentView'
  id: number
  did: l.DidString

  /**
   * The moderator assigned to this report
   */
  moderator?: TeamDefs.Member
  queue?: QueueDefs.QueueView
  reportId: number
  startAt: l.DatetimeString
  endAt?: l.DatetimeString
}

export type { AssignmentView }

const assignmentView = /*#__PURE__*/ l.typedObject<AssignmentView>(
  $nsid,
  'assignmentView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    moderator: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<TeamDefs.Member>((() => TeamDefs.member) as any),
    ),
    queue: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<QueueDefs.QueueView>(
        (() => QueueDefs.queueView) as any,
      ),
    ),
    reportId: /*#__PURE__*/ l.integer(),
    startAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    endAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { assignmentView }
